<template>
  <footer class="footer">
    <div class="footer-info">
      <div class="left-section">
        <router-link to="/">
          <img src="../assets/images/HP-icon-footer.svg" alt="" />
        </router-link>
        <p>
          Ecommerce Technology for Creators & Communities in the Philippines.
        </p>
      </div>
      <div class="right-section">
        <div class="details">
          <h4>Features</h4>
          <router-link to="/ticketing">
            <li><a>Ticketing </a></li>
          </router-link>
          <router-link to="/merch">
            <li><a>Merch </a></li>
          </router-link>
          <router-link to="/recurringpayments">
            <li><a>Recurring Payments </a></li>
          </router-link>
          <router-link to="/storefronts">
            <li><a>No-code Storefront </a></li>
          </router-link>
          <router-link to="/automatednotif">
            <li><a>Automated Notifications </a></li>
          </router-link>
          <router-link to="/apiandintegrations">
            <li><a>APIs & Integrations </a></li>
          </router-link>
          <router-link to="/analytics">
            <li><a>Analytics </a></li>
          </router-link>
        </div>

        <div class="details">
          <h4>Sectors</h4>
          <router-link to="/creators">
            <li><a>Creators </a></li>
          </router-link>
          <router-link to="/subscriptions">
            <li><a>Subscriptions </a></li>
          </router-link>
          <router-link to="/saas">
            <li><a>Saas </a></li>
          </router-link>
          <router-link to="/ecommerce">
            <li><a>E-commerce </a></li>
          </router-link>
          <router-link to="/services">
            <li><a>Services </a></li>
          </router-link>
        </div>

        <div class="details">
          <h4>Documentation</h4>
          <a href="https://helixpay.readme.io/reference/introduction">
            <p class="mb-0">API Docs</p>
          </a>
          <a href="https://docs.helixpay.ph/docs">
            <p class="mb-0">Console Docs</p>
          </a>
        </div>

        <div class="details hideOnWeb">
          <h4>More Information</h4>
          <a href="https://helixpay-console.readme.io/docs/overview">
            <p class="mb-0">FAQs</p>
          </a>
          <router-link to="/pricing">
            <li><a>Pricing </a></li>
          </router-link>
          <router-link to="/careers">
            <li><a>Careers </a></li>
          </router-link>
          <router-link to="/insights">
            <li><a>Insights </a></li>
          </router-link>
          <router-link to="/about">
            <li><a>About Us </a></li>
          </router-link>
          <router-link to="/launchpad">
            <li><a>Launchpad </a></li>
          </router-link>
          <router-link to="/incomecalculator">
            <li><a>Income Calculator </a></li>
          </router-link>
          <a href="https://helixpay.readme.io/reference/introduction">
            <p class="mb-0">For Developers</p>
          </a>
          <router-link to="/terms-conditions">
            <li>
              <p class="mb-0">Terms & Conditions</p>
            </li>
          </router-link>
          <router-link to="/privacy-policy">
            <li><p>Privacy Policy</p></li>
          </router-link>
        </div>

        <div class="details">
          <h4>Social</h4>
          <a href="https://www.facebook.com/HelixPay.ph/">
            <p class="mb-0">Facebook</p>
          </a>
          <a href="https://www.instagram.com/helixpay.creator/">
            <p class="mb-0">Instagram</p>
          </a>
          <a href="https://www.youtube.com/channel/UCUg2AS5EE2whmurvsPIjxcQ">
            <p class="mb-0">Youtube</p>
          </a>
          <a href="https://www.tiktok.com/@helixpay">
            <p class="mb-0">TikTok</p>
          </a>
        </div>

        <div class="details showOnMobile">
          <h4>More Information</h4>
          <a href="https://helixpay-console.readme.io/docs/overview">
            <p class="mb-0">FAQs</p>
          </a>
          <router-link to="/pricing">
            <li><a>Pricing </a></li>
          </router-link>
          <router-link to="/careers">
            <li><a>Careers </a></li>
          </router-link>
          <router-link to="/insights">
            <li><a>Insights </a></li>
          </router-link>
          <router-link to="/about">
            <li><a>About Us </a></li>
          </router-link>
          <router-link to="/launchpad">
            <li><a>Launchpad </a></li>
          </router-link>
          <router-link to="/incomecalculator">
            <li><a>Income Calculator </a></li>
          </router-link>
          <a href="https://helixpay.readme.io/reference/introduction">
            <p class="mb-0">For Developers</p>
          </a>
          <router-link to="/terms-conditions">
            <li>
              <p class="mb-0">Terms & Conditions</p>
            </li>
          </router-link>
          <router-link to="/privacy-policy">
            <li><p>Privacy Policy</p></li>
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup></script>

<style scoped>
.showOnMobile {
  display: none;
}

.footer {
  width: 100%;
  background-color: black;
}

.footer-info {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 5rem;
  align-items: flex-start;
  width: 95%;
  margin: auto;
  padding: 1rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
  line-height: 1.5;
}

.footer-info img {
  width: 11rem;
  height: auto;
  margin-bottom: 0.5rem;
}

.left-section p {
  opacity: 0.6;
  font-weight: 500;
  color: white;
  line-height: 2;
}

.right-section {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3rem;
}

.details h4 {
  font-size: 1rem;
  font-weight: 700;
  color: #ff5f8f;
  margin-bottom: 1rem;
}

.details li {
  list-style: none;
}

.details li a {
  opacity: 0.6;
  font-weight: 500;
  color: white;
  line-height: 2;
}

.details a {
  line-height: 2;
  text-decoration: none;
  transition: 0.2s ease-in;
}

.details p {
  opacity: 0.6;
  font-weight: 500;
  color: white;
  transition: 0.2s ease-in;
}

.details p:hover,
.details li a:hover {
  opacity: 1;
  color: #ff5f8f;
  font-weight: 500;
}

@media only screen and (max-width: 1000px) {
  .footer-info {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .right-section {
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }

  .hideOnWeb {
    display: none;
  }

  .showOnMobile {
    display: block;
  }
}
</style>
